import { useRuntimeConfig } from "#imports";
import { useMarketplace } from "@backmarket/nuxt-module-marketplace/useMarketplace";
export function useIsTranslationsSplitV2Enabled() {
  const config = useRuntimeConfig();
  const { ffTranslationsSplitV2CountriesEnabled, killTranslationsSplitV2 } = config.public.i18n;
  if (killTranslationsSplitV2) return false;
  const {
    market: { countryCode }
  } = useMarketplace();
  return ffTranslationsSplitV2CountriesEnabled?.includes(countryCode);
}
